import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../../Config';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getMasterIATAAgentCustomerDetail } from '../../../../../Redux/action/MasterAction';


const EditCustomer = ({
    customer_id,
    token,
    user_id,
    b64id,
    show,
    handleClose,
    refreshCustomer,
}) => {
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);

    useEffect(() => {
        if (customer_id) {
            dispatch(getMasterIATAAgentCustomerDetail(token, user_id, customer_id))
        }
    }, [customer_id]);



    const {
        loadingMasterIATAAgentCustomerDetail,
        MasterIATAAgentCustomerDetail,
        MasterIATAAgentCustomerDetailError
    } = useSelector(state => state.MasterReducer);

    const initialValues = {
        iata_agent_id: 0,
        company_branch_division: "",
        branch_id: 0,
        branch_name: "",
        customer_service_id: 0,
        customer_service_name: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    values.iata_agent_id = iata_agent_id
                } else {
                    toast.error("Can't add address.");
                    return;
                }
                if (!customer_id) {
                    toast.error("Can't find customer support details.")
                } else {
                    values.id = customer_id
                }
                axios.post(`${adminMainUrl}/api/iata-agent/customer/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshCustomer();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (MasterIATAAgentCustomerDetail) {
            formik.setFieldValue("company_branch_division", MasterIATAAgentCustomerDetail.company_branch_division);
            formik.setFieldValue("branch_name", MasterIATAAgentCustomerDetail.branch_name);
            formik.setFieldValue("customer_service_name", MasterIATAAgentCustomerDetail.customer_service_name);
        }
    }, [MasterIATAAgentCustomerDetail])


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Customer Service</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit} >
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="company_branch_division" className='form-label mb-0'>
                                    Select
                                </label>
                                <select
                                    className='form-control form-control-sm'
                                    id="company_branch_division"
                                    name="company_branch_division"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.company_branch_division}
                                >
                                    <option value="">-Select a value-</option>
                                    <option value="Company">Company</option>
                                    <option value="Branch">Branch</option>
                                    <option value="Division">Division</option>
                                </select>

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="branch_name" className='form-label mb-0'>
                                    Branch Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="branch_name"
                                    name='branch_name'
                                    value={formik.values.branch_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="customer_service_name" className='form-label mb-0'>
                                    Customer Service
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="customer_service_name"
                                    name='customer_service_name'
                                    value={formik.values.customer_service_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>

                        </div>
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditCustomer